import {BaseContainerModel} from '../base-container.model';
import {app_login_principal_RowClass} from '../../dbschema';

export class AppLoginPrincipalContainerModel extends BaseContainerModel {
  app_login_principal: app_login_principal_RowClass = new app_login_principal_RowClass();
}
